export const toLocalISOString = (utcDate) => {
    const localDate = new Date(utcDate);
    localDate.setHours(17, -localDate.getTimezoneOffset(), 0, 0);
    return localDate;
}